import { useFormatAmount } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';
import { type TopUpProps, useTopUpDrawer } from '@capsicum/features/topup/shared';
import styled from 'styled-components';

export const TopUp = ({
	amountFiatNeeded,
	chzRate,
	closeModal,
	fiatCurrencyShortCode,
	onButtonPressed,
	testID,
	userAmount
}: TopUpProps) => {
	const { formatAmount } = useFormatAmount();
	const { texts } = useTopUpDrawer();

	return (
		<GenericDrawer
			buttonText={texts.buttonLabel}
			description={texts.description}
			isButtonFullWidth
			testID={testID}
			title={texts.title}
			onButtonPress={() => {
				onButtonPressed();
				closeModal();
			}}
		>
			<S.BalanceTable>
				<S.BalanceTitle>{texts.yourBalance}</S.BalanceTitle>
				<div>
					<S.BalanceValue>{formatAmount(userAmount / chzRate)}</S.BalanceValue>
					<S.BalanceValue>{`${formatAmount(userAmount)} ${fiatCurrencyShortCode}`}</S.BalanceValue>
				</div>
			</S.BalanceTable>
			<S.StyledDivider />
			<S.AmountNeededTable>
				<S.AmountNeededTitle>{texts.amountNeeded}</S.AmountNeededTitle>
				<div>
					<S.AmountNeededValue>{formatAmount(amountFiatNeeded / chzRate)}</S.AmountNeededValue>
					<S.AmountNeededValue>
						{`${formatAmount(amountFiatNeeded)} ${fiatCurrencyShortCode}`}
					</S.AmountNeededValue>
				</div>
			</S.AmountNeededTable>
		</GenericDrawer>
	);
};

namespace S {
	export const BalanceTable = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.input};
		${({ theme }) => theme.border.radius.medium};
		padding: ${({ theme }) => `${theme.spacings.xxsmall} ${theme.spacings.small}`};
		margin-top: ${({ theme }) => theme.spacings.small};
	`;

	export const BalanceTitle = styled.div`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const BalanceValue = styled.div`
		color: ${({ theme }) => theme.colors.text.destructive.enabled};
		${({ theme }) => theme.fonts.text.text5};
		text-align: right;
	`;

	export const StyledDivider = styled.div`
		border-top: 1px solid ${({ theme }) => theme.colors.borders.main.divider};
		margin-top: ${({ theme }) => theme.spacings.small};
		margin-bottom: ${({ theme }) => theme.spacings.small};
	`;

	export const AmountNeededTable = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: ${({ theme }) => `${theme.spacings.xsmall} 0 ${theme.spacings.xxxsmall} 0`};
	`;

	export const AmountNeededTitle = styled.div`
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const AmountNeededValue = styled.div`
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		text-align: right;
	`;
}
